import {
  Bell,
  BookOpen,
  Building2,
  Boxes,
  CalendarClock,
  CalendarRange,
  Contact,
  Factory,
  FileText,
  HandCoins,
  History,
  LayoutDashboard,
  LayoutGrid,
  MessagesSquare,
  PackageMinus,
  PackagePlus,
  Plug,
  ReceiptText,
  Settings,
  ShieldCheck,
  Shirt,
  ShoppingBag,
  Tags,
  Target,
  Undo2,
  UserCog,
  Users,
  Wallet,
  Warehouse,
  type LucideIcon,
} from 'lucide-react';

/**
 * The module registry in `@erp-boilerplate/shared` is framework-agnostic and
 * stores icons as names. This is where those names become React components — the
 * one place the shared package's string identifiers meet lucide.
 *
 * Only the icons the registry actually names are imported, so the bundle carries
 * the navigation set rather than the whole library. Add yours here when you add a
 * module.
 */
const ICONS: Record<string, LucideIcon> = {
  Bell,
  BookOpen,
  Boxes,
  Building2,
  CalendarClock,
  CalendarRange,
  Contact,
  // Phase 11 named these three in the registry without mapping them, so the
  // vendor, purchase and payables entries fell back to the neutral glyph.
  Factory,
  FileText,
  HandCoins,
  History,
  LayoutDashboard,
  LayoutGrid,
  MessagesSquare,
  PackageMinus,
  PackagePlus,
  Plug,
  ReceiptText,
  Settings,
  ShieldCheck,
  Shirt,
  ShoppingBag,
  Tags,
  Target,
  Undo2,
  UserCog,
  Users,
  Wallet,
  Warehouse,
};

/** Falls back to a neutral glyph so an unmapped name never crashes the sidebar. */
export const resolveIcon = (name: string): LucideIcon => ICONS[name] ?? LayoutGrid;
